import { Navigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import { ROUTES } from '../../const/routes';
import styles from './AdminProtectedRoute.module.css';

const AdminProtectedRoute = ({ children }) => {
  const { userData, isLoading } = useUser();

  // Mientras se está verificando la sesión, mostrar pantalla de carga
  if (isLoading) {
    return (
      <div
        className={
          'flex flex-col items-center justify-center min-h-screen ' +
          styles.loadingContainer
        }
      >
        <h2 className="text-4xl text-yellow-500 font-bold mb-2">Cargando...</h2>
      </div>
    );
  }

  // No autenticado → login
  if (!userData) {
    return <Navigate to={ROUTES.login} replace />;
  }

  // No es administrador → redirigir a juegos
  if (userData.id_rol !== 2) {
    return <Navigate to={ROUTES.listaJuegos} replace />;
  }

  return children;
};

export default AdminProtectedRoute;
